export default __webpack_public_path__ + "static/media/EM1680.34I-39298_-23341_0.430e941c.jpg";